// import React, { useState, useEffect } from "react";

// const ResumeHeader = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [typingText, setTypingText] = useState("");
//   const [currentWordIndex, setCurrentWordIndex] = useState(0);
//   const [isTyping, setIsTyping] = useState(true);
//   const [particles, setParticles] = useState([]);
//   const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

//   // Dynamic typing words
//   const typingWords = [
//     "Blockchain Developer",
//     "Smart Contract Engineer",
//     "DApp Architect",
//     "Web3 Innovator",
//     "Hyperledger Expert",
//   ];

//   // Personal Information
//   const personalInfo = {
//     name: "MANEESH MADHUSUDHANAN",
//     title: "Blockchain Developer & Smart Contract Engineer",
//     location: "Kerala, India",
//     phone: "+91 8281422036",
//     email: "maneeshroks@gmail.com",
//     github: "https://github.com/maneeshmadhusudhanan",
//     linkedin: "https://linkedin.com/in/maneesh-madhusudhanan",
//     profileImage:
//       "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face",
//   };

//   // Generate floating particles
//   useEffect(() => {
//     const generateParticles = () => {
//       const newParticles = [];
//       for (let i = 0; i < 50; i++) {
//         newParticles.push({
//           id: i,
//           x: Math.random() * window.innerWidth,
//           y: Math.random() * window.innerHeight,
//           size: Math.random() * 3 + 1,
//           speedX: (Math.random() - 0.5) * 0.5,
//           speedY: (Math.random() - 0.5) * 0.5,
//           opacity: Math.random() * 0.4 + 0.1,
//           color: `hsl(${Math.random() * 60 + 200}, 70%, 60%)`,
//         });
//       }
//       setParticles(newParticles);
//     };

//     generateParticles();
//     setIsVisible(true);

//     const animateParticles = () => {
//       setParticles((prev) =>
//         prev.map((particle) => ({
//           ...particle,
//           x: particle.x + particle.speedX,
//           y: particle.y + particle.speedY,
//           x:
//             particle.x > window.innerWidth
//               ? 0
//               : particle.x < 0
//               ? window.innerWidth
//               : particle.x,
//           y:
//             particle.y > window.innerHeight
//               ? 0
//               : particle.y < 0
//               ? window.innerHeight
//               : particle.y,
//         }))
//       );
//     };

//     const particleInterval = setInterval(animateParticles, 100);
//     return () => clearInterval(particleInterval);
//   }, []);

//   // Mouse tracking
//   useEffect(() => {
//     const handleMouseMove = (e) => {
//       setMousePosition({ x: e.clientX, y: e.clientY });
//     };
//     window.addEventListener("mousemove", handleMouseMove);
//     return () => window.removeEventListener("mousemove", handleMouseMove);
//   }, []);

//   // Dynamic typing effect
//   useEffect(() => {
//     const currentWord = typingWords[currentWordIndex];

//     if (isTyping) {
//       if (typingText.length < currentWord.length) {
//         const timeout = setTimeout(() => {
//           setTypingText(currentWord.substring(0, typingText.length + 1));
//         }, 120);
//         return () => clearTimeout(timeout);
//       } else {
//         const timeout = setTimeout(() => {
//           setIsTyping(false);
//         }, 2000);
//         return () => clearTimeout(timeout);
//       }
//     } else {
//       if (typingText.length > 0) {
//         const timeout = setTimeout(() => {
//           setTypingText(typingText.substring(0, typingText.length - 1));
//         }, 80);
//         return () => clearTimeout(timeout);
//       } else {
//         setCurrentWordIndex((prev) => (prev + 1) % typingWords.length);
//         setIsTyping(true);
//       }
//     }
//   }, [typingText, isTyping, currentWordIndex, typingWords]);

//   const socialLinks = [
//     {
//       name: "Email",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//           />
//         </svg>
//       ),
//       link: `mailto:${personalInfo.email}`,
//       color: "from-red-500 to-pink-500",
//       label: personalInfo.email,
//     },
//     {
//       name: "Phone",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//           />
//         </svg>
//       ),
//       link: `tel:${personalInfo.phone}`,
//       color: "from-green-500 to-teal-500",
//       label: personalInfo.phone,
//     },
//     {
//       name: "GitHub",
//       icon: (
//         <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
//         </svg>
//       ),
//       link: personalInfo.github,
//       color: "from-gray-700 to-gray-900",
//       label: "GitHub",
//     },
//     {
//       name: "LinkedIn",
//       icon: (
//         <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
//         </svg>
//       ),
//       link: personalInfo.linkedin,
//       color: "from-blue-600 to-blue-800",
//       label: "LinkedIn",
//     },
//     {
//       name: "Location",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//           />
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//           />
//         </svg>
//       ),
//       link: "#",
//       color: "from-purple-500 to-indigo-500",
//       label: personalInfo.location,
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
//       {/* Animated Background Particles */}
//       <div className="absolute inset-0 pointer-events-none">
//         {particles.map((particle) => (
//           <div
//             key={particle.id}
//             className="absolute rounded-full animate-pulse"
//             style={{
//               left: `${particle.x}px`,
//               top: `${particle.y}px`,
//               width: `${particle.size}px`,
//               height: `${particle.size}px`,
//               backgroundColor: particle.color,
//               opacity: particle.opacity,
//             }}
//           />
//         ))}
//       </div>

//       {/* Mouse Follower */}
//       <div
//         className="fixed w-8 h-8 bg-blue-400/30 rounded-full pointer-events-none z-50 transition-transform duration-200 animate-pulse"
//         style={{
//           left: `${mousePosition.x - 16}px`,
//           top: `${mousePosition.y - 16}px`,
//           transform: `scale(${Math.sin(Date.now() * 0.005) * 0.5 + 1})`,
//         }}
//       />

//       {/* Grid Pattern Overlay */}
//       <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=%2240%22 height=%2240%22 viewBox=%220 0 40 40%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22%23ffffff%22 fill-opacity=%220.05%22%3E%3Cpath d=%22M40 40V0H0v40h40z%22/%3E%3C/g%3E%3C/svg%3E')] opacity-20"></div>

//       {/* Main Content */}
//       <div className="relative z-10 container mx-auto px-6 py-12 flex items-center min-h-screen">
//         <div className="w-full max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//             {/* Left Column - Text Content */}
//             <div
//               className={`space-y-8 transition-all duration-1000 ${
//                 isVisible
//                   ? "opacity-100 translate-x-0"
//                   : "opacity-0 -translate-x-12"
//               }`}
//             >
//               {/* Greeting */}
//               <div className="space-y-2">
//                 <p className="text-blue-400 text-lg md:text-xl font-semibold tracking-wide uppercase animate-pulse">
//                   Hello, I'm
//                 </p>

//                 {/* Name with gradient */}
//                 <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-200 to-purple-300 leading-tight">
//                   {personalInfo.name}
//                 </h1>
//               </div>

//               {/* Dynamic Typing Title */}
//               <div className="h-20 flex items-center">
//                 <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-blue-400">
//                   <span className="text-white mr-2">I'm a</span>
//                   <span className="relative">
//                     {typingText}
//                     <span className="animate-pulse text-blue-400">|</span>
//                   </span>
//                 </h2>
//               </div>

//               {/* Description */}
//               <div className="space-y-6">
//                 <p className="text-gray-300 text-lg md:text-xl leading-relaxed max-w-2xl">
//                   Passionate blockchain developer specializing in{" "}
//                   <span className="text-blue-400 font-semibold">
//                     Hyperledger Fabric
//                   </span>{" "}
//                   and{" "}
//                   <span className="text-purple-400 font-semibold">
//                     Ethereum smart contracts
//                   </span>
//                   . Building the decentralized future with innovative Web3
//                   solutions.
//                 </p>

//                 {/* Key Stats */}
//                 <div className="grid grid-cols-3 gap-6 py-6">
//                   {[
//                     { number: "4+", label: "Projects", icon: "🚀" },
//                     { number: "5+", label: "Months Exp", icon: "⏱️" },
//                     { number: "20+", label: "Technologies", icon: "⚡" },
//                   ].map((stat, index) => (
//                     <div
//                       key={index}
//                       className={`text-center group cursor-pointer transition-all duration-500 hover:scale-110 ${
//                         isVisible
//                           ? "opacity-100 translate-y-0"
//                           : "opacity-0 translate-y-4"
//                       }`}
//                       style={{ transitionDelay: `${600 + index * 200}ms` }}
//                     >
//                       <div className="text-2xl mb-2 group-hover:animate-bounce">
//                         {stat.icon}
//                       </div>
//                       <div className="text-2xl md:text-3xl font-bold text-white mb-1 group-hover:text-blue-400 transition-colors">
//                         {stat.number}
//                       </div>
//                       <div className="text-gray-400 text-sm uppercase tracking-wide">
//                         {stat.label}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* CTA Buttons */}
//               <div
//                 className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 ${
//                   isVisible
//                     ? "opacity-100 translate-y-0"
//                     : "opacity-0 translate-y-8"
//                 }`}
//                 style={{ transitionDelay: "1000ms" }}
//               >
//                 <button className="group relative px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold rounded-full overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/25">
//                   <span className="relative z-10 flex items-center justify-center">
//                     <svg
//                       className="w-5 h-5 mr-2 group-hover:animate-bounce"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                       />
//                     </svg>
//                     Download Resume
//                   </span>
//                   <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                 </button>

//                 <button className="px-8 py-4 border-2 border-blue-400 text-blue-400 font-bold rounded-full hover:bg-blue-400 hover:text-white transition-all duration-300 transform hover:scale-105 flex items-center justify-center group">
//                   <svg
//                     className="w-5 h-5 mr-2 group-hover:animate-ping"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
//                     />
//                   </svg>
//                   Let's Connect
//                 </button>
//               </div>
//             </div>

//             {/* Right Column - Profile & Contact */}
//             <div
//               className={`space-y-8 transition-all duration-1000 ${
//                 isVisible
//                   ? "opacity-100 translate-x-0"
//                   : "opacity-0 translate-x-12"
//               }`}
//               style={{ transitionDelay: "400ms" }}
//             >
//               {/* Profile Image with 3D Effect */}
//               <div className="relative group cursor-pointer mx-auto lg:mx-0 w-80 h-80">
//                 {/* Glowing Ring */}
//                 <div
//                   className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 animate-spin"
//                   style={{ animationDuration: "8s" }}
//                 ></div>

//                 {/* Image Container */}
//                 <div className="absolute inset-2 rounded-full overflow-hidden group-hover:inset-1 transition-all duration-500">
//                   <div className="w-full h-full bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 rounded-full flex items-center justify-center text-8xl animate-pulse">
//                     👨‍💻
//                   </div>

//                   {/* Overlay on hover */}
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 rounded-full flex items-end justify-center pb-8">
//                     <p className="text-white font-bold text-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
//                       {personalInfo.title}
//                     </p>
//                   </div>
//                 </div>

//                 {/* Floating Badges */}
//                 <div className="absolute -top-4 -right-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-bold animate-bounce">
//                   Available
//                 </div>
//                 <div className="absolute -bottom-4 -left-4 bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-bold animate-pulse">
//                   Blockchain Expert
//                 </div>
//               </div>

//               {/* Contact Information */}
//               <div className="space-y-4">
//                 <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
//                   <span className="mr-3">📞</span> Get in Touch
//                 </h3>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                   {socialLinks.map((social, index) => (
//                     <a
//                       key={social.name}
//                       href={social.link}
//                       target={
//                         social.name !== "Phone" && social.name !== "Email"
//                           ? "_blank"
//                           : "_self"
//                       }
//                       rel="noopener noreferrer"
//                       className={`group relative p-4 rounded-xl bg-gradient-to-r ${social.color} transform transition-all duration-300 hover:scale-105 hover:-translate-y-1 hover:shadow-2xl`}
//                       style={{ transitionDelay: `${800 + index * 100}ms` }}
//                     >
//                       <div className="flex items-center space-x-3">
//                         <div className="text-white group-hover:scale-125 transition-transform duration-300">
//                           {social.icon}
//                         </div>
//                         <div className="flex-1">
//                           <p className="text-white font-bold text-sm uppercase tracking-wide">
//                             {social.name}
//                           </p>
//                           <p className="text-white/90 text-xs truncate">
//                             {social.label}
//                           </p>
//                         </div>
//                       </div>

//                       {/* Hover Effect */}
//                       <div className="absolute inset-0 bg-white/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                     </a>
//                   ))}
//                 </div>
//               </div>

//               {/* Quick Skills Preview */}
//               <div
//                 className={`bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 transition-all duration-1000 hover:bg-white/20 ${
//                   isVisible
//                     ? "opacity-100 translate-y-0"
//                     : "opacity-0 translate-y-8"
//                 }`}
//                 style={{ transitionDelay: "1200ms" }}
//               >
//                 <h4 className="text-white font-bold mb-4 flex items-center">
//                   <span className="mr-2">🔧</span> Core Technologies
//                 </h4>
//                 <div className="flex flex-wrap gap-2">
//                   {[
//                     "Hyperledger Fabric",
//                     "Ethereum",
//                     "Solidity",
//                     "React.js",
//                     "Node.js",
//                     "Docker",
//                   ].map((tech, index) => (
//                     <span
//                       key={tech}
//                       className={`px-3 py-1 bg-blue-500/20 text-blue-300 rounded-full text-sm font-medium border border-blue-500/30 hover:bg-blue-500/30 transition-all duration-300 cursor-pointer transform hover:scale-110`}
//                       style={{ transitionDelay: `${1400 + index * 100}ms` }}
//                     >
//                       {tech}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Scroll Indicator */}
//       <div
//         className={`absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce transition-all duration-1000 ${
//           isVisible ? "opacity-100" : "opacity-0"
//         }`}
//         style={{ transitionDelay: "1600ms" }}
//       >
//         <div className="flex flex-col items-center space-y-2">
//           <p className="text-sm uppercase tracking-wide">Scroll Down</p>
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M19 14l-7 7m0 0l-7-7m7 7V3"
//             />
//           </svg>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResumeHeader;

import React, { useState, useEffect, useRef } from "react";

const Resume = () => {
  const [activeSection, setActiveSection] = useState("overview");
  const [isVisible, setIsVisible] = useState(false);
  const [animatedStats, setAnimatedStats] = useState({
    projects: 0,
    experience: 0,
    skills: 0,
  });
  const [downloadStatus, setDownloadStatus] = useState("idle"); // idle, downloading, success, error
  const sectionRef = useRef(null);

  // Personal Information
  const personalInfo = {
    name: "MANEESH MADHUSUDHANAN",
    title: "Blockchain Developer & Smart Contract Engineer",
    location: "Kerala, India",
    phone: "+91 8281422036",
    email: "maneeshroks@gmail.com",
    github: "https://github.com/maneeshmadhusudhanan",
    linkedin: "https://linkedin.com/in/maneesh-madhusudhanan",
    objective:
      "Blockchain Developer with expertise in Hyperledger Fabric and Ethereum smart contracts. Seeking opportunities to develop decentralized solutions in collaborative environments.",
  };

  // Updated Resume Data
  const resumeData = {
    education: [
      {
        degree: "PG Diploma in Blockchain Technology",
        institution: "Digital University Kerala",
        year: "2025",
        status: "Completed",
        icon: "🎓",
      },
      {
        degree: "B.Tech in Electrical & Electronics",
        institution: "CUSAT",
        year: "2018",
        status: "Graduated",
        icon: "⚡",
      },
    ],
    experience: [
      {
        position: "Blockchain Intern",
        company: "Kerala Blockchain Academy",
        location: "Thiruvananthapuram",
        duration: "Apr 2025 – Aug 2025",
        responsibilities: [
          "Developed DAO governance UI using React.js and Ethereum smart contracts",
          "Created/deployed ERC20 governance and farming tokens (Sepolia)",
          "Integrated Uniswap liquidity and explored IoT-aquaponics DAO use case",
        ],
        icon: "💼",
      },
    ],
    projects: [
      {
        name: "VehicleBlacklistChain",
        tech: "Hyperledger Fabric, Go",
        description:
          "Decentralized vehicle theft reporting system with secure registration and blacklist verification.",
        icon: "🚗",
        category: "Blockchain",
      },
      {
        name: "CryptoLedger Exchange",
        tech: "Ethereum, React",
        description:
          "DEX with ERC-20 token (2% fee), JWT auth, and transaction tracking.",
        icon: "💱",
        category: "DeFi",
      },
      {
        name: "SmartFacebook DApp",
        tech: "Ethereum, IPFS",
        description:
          "Decentralized social media with token rewards and content storage.",
        icon: "📱",
        category: "DApp",
      },
      {
        name: "JobLadder",
        tech: "MERN Stack",
        description: "Job portal with resume parsing functionality.",
        icon: "💼",
        category: "Web App",
      },
    ],
    skills: {
      blockchain: [
        "Ethereum",
        "Solidity",
        "Hardhat",
        "Hyperledger Fabric",
        "ERC-20/721",
        "DAO",
      ],
      frontend: ["React.js", "Next.js", "Tailwind CSS", "JavaScript"],
      backend: ["Node.js", "Express.js", "REST APIs", "MongoDB", "MySQL"],
      tools: ["Git", "Docker", "Remix", "Postman", "VS Code"],
      soft: ["Problem Solving", "Teamwork", "Leadership", "Time Management"],
    },
    development: {
      workshops: [
        "EthWalk (Devcon Roadshow)",
        "Avalanche L1 Deployment",
        "Blockchain in Agriculture (KBA-DailyGurus)",
        "Decentralized Identity & Credentials (KBA & AyanWorks)",
      ],
      certifications: [
        "Certified Hyperledger Fabric Developer",
        "Blockchain Foundation Course",
        "Developer Essentials for Blockchain (Kerala Blockchain Academy)",
      ],
      focus: [
        "Enterprise integration",
        "Traceability in agritech",
        "Web3 governance",
        "Tokenomics",
        "Smart contract security",
        "Blockchain identity systems",
      ],
    },
    languages: [
      { name: "English", level: "Fluent", percentage: 95 },
      { name: "Malayalam", level: "Native", percentage: 100 },
      { name: "Hindi", level: "Conversational", percentage: 75 },
      { name: "Tamil", level: "Basic", percentage: 60 },
    ],
  };

  const stats = [
    { label: "Projects Completed", value: 4, suffix: "+" },
    { label: "Months Experience", value: 5, suffix: "" },
    { label: "Technologies Mastered", value: 20, suffix: "+" },
  ];

  // Intersection Observer Effect
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Animate stats
          stats.forEach((stat, index) => {
            setTimeout(() => {
              animateStat(
                stat.label.toLowerCase().includes("project")
                  ? "projects"
                  : stat.label.toLowerCase().includes("experience")
                  ? "experience"
                  : "skills",
                stat.value
              );
            }, index * 500);
          });
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const animateStat = (key, target) => {
    let current = 0;
    const increment = target / 30;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      setAnimatedStats((prev) => ({ ...prev, [key]: Math.floor(current) }));
    }, 50);
  };

  // Download Resume Handler
  const handleDownloadResume = async () => {
    setDownloadStatus("downloading");

    try {
      // Simulate PDF generation/download
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Updated resume content
      const resumeContent = generateUpdatedResumeText();
      const blob = new Blob([resumeContent], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "Maneesh_Madhusudhanan_Resume.txt";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      setDownloadStatus("success");
      setTimeout(() => setDownloadStatus("idle"), 3000);
    } catch (error) {
      console.error("Download failed:", error);
      setDownloadStatus("error");
      setTimeout(() => setDownloadStatus("idle"), 3000);
    }
  };

  const generateUpdatedResumeText = () => {
    return `MANEESH MADHUSUDHANAN
+91 8281422036 ⋄ Kerala, India
maneeshroks@gmail.com ⋄ Github ⋄ Linkedin

OBJECTIVE
Blockchain Developer with expertise in Hyperledger Fabric and Ethereum smart contracts. Seeking opportunities to develop decentralized solutions in collaborative environments.

EDUCATION
PG Diploma in Blockchain Technology, Digital University Kerala                                    2025
B.Tech in Electrical & Electronics, CUSAT                                                       2018

SKILLS
Blockchain: Ethereum, Solidity, Hardhat, Hyperledger Fabric, ERC-20/721, DAO
Frontend: React.js, Next.js, Tailwind CSS, JavaScript
Backend: Node.js, Express.js, REST APIs, MongoDB, MySQL
Tools: Git, Docker, Remix, Postman, VS Code
Soft Skills: Problem Solving, Teamwork, Leadership, Time Management

PROFESSIONAL EXPERIENCE
Blockchain Intern
Kerala Blockchain Academy, Thiruvananthapuram                                        Apr 2025 – Aug 2025
• Developed DAO governance UI using React.js and Ethereum smart contracts
• Created/deployed ERC20 governance and farming tokens (Sepolia)
• Integrated Uniswap liquidity and explored IoT-aquaponics DAO use case

PROJECTS
VehicleBlacklistChain (Hyperledger Fabric, Go): Decentralized vehicle theft reporting system with secure registration and blacklist verification.

CryptoLedger Exchange (Ethereum, React): DEX with ERC-20 token (2% fee), JWT auth, and transaction tracking.

SmartFacebook DApp (Ethereum, IPFS): Decentralized social media with token rewards and content storage.

JobLadder (MERN Stack): Job portal with resume parsing.

PROFESSIONAL DEVELOPMENT
• Workshops & Events: EthWalk (Devcon Roadshow), Avalanche L1 Deployment, Blockchain in Agriculture (KBA-DailyGurus), Decentralized Identity & Credentials (KBA & AyanWorks)
• Certifications: Certified Hyperledger Fabric Developer, Blockchain Foundation Course, Developer Essentials for Blockchain (Kerala Blockchain Academy)
• Learning Focus: Enterprise integration, traceability in agritech, Web3 governance, tokenomics, smart contract security, and blockchain identity systems.

LANGUAGES
English (Fluent), Malayalam (Native), Hindi (Conversational), Tamil`;
  };

  const SkillBar = ({ skill, percentage, delay }) => (
    <div
      className={`mb-4 transition-all duration-500 ${
        isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="flex justify-between items-center mb-2">
        <span className="font-medium text-gray-700">{skill}</span>
        <span className="text-sm text-blue-600 font-semibold">
          {percentage}%
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-full transition-all duration-1500 ease-out"
          style={{
            width: isVisible ? `${percentage}%` : "0%",
            transitionDelay: `${delay + 300}ms`,
          }}
        />
      </div>
    </div>
  );

  const ProjectCard = ({ project, index }) => (
    <div
      className={`
      bg-white rounded-xl p-6 shadow-lg border-l-4 border-blue-500 hover:shadow-xl
      transform transition-all duration-500 hover:-translate-y-1
      ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
    `}
      style={{ transitionDelay: `${index * 150}ms` }}
    >
      <div className="flex items-start space-x-4 mb-4">
        <div className="text-3xl">{project.icon}</div>
        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-xl font-bold text-gray-900">{project.name}</h4>
            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
              {project.category}
            </span>
          </div>
          <p className="text-blue-600 font-medium text-sm mb-3">
            {project.tech}
          </p>
          <p className="text-gray-700 leading-relaxed">{project.description}</p>
        </div>
      </div>
    </div>
  );

  const sections = {
    overview: (
      <div className="space-y-8">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`
              bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6 text-center
              transform transition-all duration-500 hover:scale-105 hover:shadow-lg
              ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-4"
              }
            `}
              style={{ transitionDelay: `${index * 200}ms` }}
            >
              <div className="text-3xl font-bold text-blue-600 mb-2">
                {stat.label.includes("Projects")
                  ? animatedStats.projects
                  : stat.label.includes("Experience") ||
                    stat.label.includes("Months")
                  ? animatedStats.experience
                  : animatedStats.skills}
                {stat.suffix}
              </div>
              <div className="text-sm text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Objective */}
        <div
          className={`bg-white rounded-xl p-6 shadow-lg border-l-4 border-blue-500
          transition-all duration-500 ${
            isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"
          }`}
        >
          <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
            <span className="mr-3">🎯</span> Career Objective
          </h3>
          <p className="text-gray-700 leading-relaxed">
            {personalInfo.objective}
          </p>
        </div>

        {/* Key Highlights */}
        <div
          className={`bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white
          transition-all duration-500 ${
            isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"
          }`}
          style={{ transitionDelay: "400ms" }}
        >
          <h3 className="text-xl font-bold mb-4">🚀 Key Highlights</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span>Hyperledger Fabric Certified Developer</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span>4+ Blockchain Projects Deployed</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span>Smart Contract Security Expert</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span>Full-Stack DApp Development</span>
            </div>
          </div>
        </div>
      </div>
    ),

    education: (
      <div className="space-y-6">
        {resumeData.education.map((edu, index) => (
          <div
            key={index}
            className={`
            bg-white rounded-xl p-6 shadow-lg hover:shadow-xl border border-gray-100
            transform transition-all duration-500 hover:-translate-y-1
            ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }
          `}
            style={{ transitionDelay: `${index * 200}ms` }}
          >
            <div className="flex items-start space-x-4">
              <div className="text-3xl">{edu.icon}</div>
              <div className="flex-1">
                <h4 className="text-xl font-bold text-gray-900 mb-2">
                  {edu.degree}
                </h4>
                <p className="text-blue-600 font-medium mb-2">
                  {edu.institution}
                </p>
                <div className="flex items-center space-x-4">
                  <span className="text-gray-600 flex items-center">
                    <svg
                      className="w-4 h-4 mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    {edu.year}
                  </span>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      edu.status === "Completed"
                        ? "bg-green-100 text-green-800"
                        : "bg-blue-100 text-blue-800"
                    }`}
                  >
                    {edu.status}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ),

    experience: (
      <div className="space-y-6">
        {resumeData.experience.map((exp, index) => (
          <div
            key={index}
            className={`
            bg-white rounded-xl p-6 shadow-lg border-l-4 border-blue-500
            transition-all duration-500 ${
              isVisible
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-4"
            }`}
            style={{ transitionDelay: `${index * 200}ms` }}
          >
            <div className="flex items-start space-x-4 mb-4">
              <div className="text-3xl">{exp.icon}</div>
              <div className="flex-1">
                <h4 className="text-xl font-bold text-gray-900 mb-1">
                  {exp.position}
                </h4>
                <p className="text-blue-600 font-medium mb-2">
                  {exp.company}, {exp.location}
                </p>
                <span className="text-gray-600 text-sm bg-gray-100 px-3 py-1 rounded-full">
                  {exp.duration}
                </span>
              </div>
            </div>
            <div className="space-y-2">
              <h5 className="font-semibold text-gray-800 mb-3">
                Key Responsibilities:
              </h5>
              {exp.responsibilities.map((resp, respIndex) => (
                <div key={respIndex} className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">{resp}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ),

    projects: (
      <div className="space-y-6">
        {resumeData.projects.map((project, index) => (
          <ProjectCard key={project.name} project={project} index={index} />
        ))}
      </div>
    ),

    skills: (
      <div className="space-y-8">
        {Object.entries(resumeData.skills).map(
          ([category, skills], categoryIndex) => (
            <div
              key={category}
              className={`
            bg-white rounded-xl p-6 shadow-lg
            transition-all duration-500 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }
          `}
              style={{ transitionDelay: `${categoryIndex * 150}ms` }}
            >
              <h4 className="text-lg font-bold text-gray-900 mb-4 capitalize flex items-center">
                <span className="mr-2">
                  {category === "blockchain"
                    ? "⛓️"
                    : category === "frontend"
                    ? "🎨"
                    : category === "backend"
                    ? "⚙️"
                    : category === "tools"
                    ? "🛠️"
                    : "🧠"}
                </span>
                {category.charAt(0).toUpperCase() + category.slice(1)} Skills
              </h4>
              <div className="flex flex-wrap gap-2">
                {skills.map((skill, skillIndex) => (
                  <span
                    key={skillIndex}
                    className={`
                  px-3 py-1 bg-gradient-to-r from-blue-100 to-purple-100 text-blue-800 rounded-full text-sm font-medium
                  transform transition-all duration-300 hover:scale-105 hover:shadow-md cursor-default
                  ${
                    isVisible
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-2"
                  }
                `}
                    style={{
                      transitionDelay: `${
                        categoryIndex * 150 + skillIndex * 50
                      }ms`,
                    }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          )
        )}

        {/* Language Skills */}
        <div
          className={`bg-white rounded-xl p-6 shadow-lg
          transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
          style={{ transitionDelay: "600ms" }}
        >
          <h4 className="text-lg font-bold text-gray-900 mb-6 flex items-center">
            <span className="mr-2">🌐</span> Languages
          </h4>
          {resumeData.languages.map((lang, index) => (
            <SkillBar
              key={lang.name}
              skill={`${lang.name} (${lang.level})`}
              percentage={lang.percentage}
              delay={index * 100}
            />
          ))}
        </div>
      </div>
    ),

    development: (
      <div className="space-y-6">
        {/* Workshops */}
        <div
          className={`bg-white rounded-xl p-6 shadow-lg
          transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
            <span className="mr-2">🎓</span> Workshops & Events
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {resumeData.development.workshops.map((workshop, index) => (
              <div
                key={index}
                className={`
                flex items-center space-x-3 p-3 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg
                transition-all duration-300 hover:shadow-md
                ${
                  isVisible
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 -translate-x-2"
                }
              `}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-2 h-2 bg-purple-500 rounded-full flex-shrink-0"></div>
                <span className="text-gray-700 font-medium text-sm">
                  {workshop}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div
          className={`bg-white rounded-xl p-6 shadow-lg
          transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
          style={{ transitionDelay: "200ms" }}
        >
          <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
            <span className="mr-2">🏆</span> Professional Certifications
          </h4>
          <div className="space-y-3">
            {resumeData.development.certifications.map((cert, index) => (
              <div
                key={index}
                className={`
                flex items-center space-x-3 p-3 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg
                transition-all duration-300 hover:shadow-md
                ${
                  isVisible
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 -translate-x-2"
                }
              `}
                style={{ transitionDelay: `${200 + index * 100}ms` }}
              >
                <div className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0"></div>
                <span className="text-gray-700 font-medium">{cert}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Learning Focus */}
        <div
          className={`bg-white rounded-xl p-6 shadow-lg
          transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
          style={{ transitionDelay: "400ms" }}
        >
          <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
            <span className="mr-2">🎯</span> Learning Focus Areas
          </h4>
          <div className="flex flex-wrap gap-2">
            {resumeData.development.focus.map((focus, index) => (
              <span
                key={index}
                className={`
                px-3 py-1 bg-gradient-to-r from-orange-100 to-red-100 text-orange-800 rounded-full text-sm font-medium
                transform transition-all duration-300 hover:scale-105 hover:shadow-md cursor-default
                ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-2"
                }
              `}
                style={{ transitionDelay: `${400 + index * 50}ms` }}
              >
                {focus}
              </span>
            ))}
          </div>
        </div>
      </div>
    ),
  };

  return (
    <section
      ref={sectionRef}
      id="resume"
      className="py-20 bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 min-h-screen"
    >
      <div className="container mx-auto px-4">
        {/* Header */}
        <div
          className={`text-center mb-12 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="inline-block p-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6">
            <div className="bg-white rounded-full px-6 py-2">
              <span className="text-sm font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                BLOCKCHAIN DEVELOPER PORTFOLIO
              </span>
            </div>
          </div>

          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">
            {personalInfo.name}
          </h2>
          <p className="text-xl md:text-2xl text-blue-600 font-medium mb-6">
            {personalInfo.title}
          </p>

          {/* Contact Information */}
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <div className="flex items-center space-x-2 text-gray-600">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span>{personalInfo.location}</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-600">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <span>{personalInfo.phone}</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-600">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <span>{personalInfo.email}</span>
            </div>
          </div>

          {/* Download Resume Button */}
          <button
            onClick={handleDownloadResume}
            disabled={downloadStatus === "downloading"}
            className={`
              inline-flex items-center space-x-3 px-8 py-4 rounded-full font-semibold
              transition-all duration-300 transform hover:scale-105 shadow-lg
              ${
                downloadStatus === "downloading"
                  ? "bg-gray-400 cursor-not-allowed"
                  : downloadStatus === "success"
                  ? "bg-green-500 text-white"
                  : downloadStatus === "error"
                  ? "bg-red-500 text-white"
                  : "bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700"
              }
            `}
          >
            {downloadStatus === "downloading" ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                <span>Generating Resume...</span>
              </>
            ) : downloadStatus === "success" ? (
              <>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span>Resume Downloaded!</span>
              </>
            ) : downloadStatus === "error" ? (
              <>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                <span>Download Failed - Retry</span>
              </>
            ) : (
              <>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <span>Download Resume</span>
              </>
            )}
          </button>
        </div>

        {/* Navigation Tabs */}
        <div
          className={`flex flex-wrap justify-center gap-2 mb-12 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
          style={{ transitionDelay: "200ms" }}
        >
          {[
            { key: "overview", label: "Overview", icon: "👨‍💼" },
            { key: "education", label: "Education", icon: "🎓" },
            { key: "experience", label: "Experience", icon: "💼" },
            { key: "projects", label: "Projects", icon: "🚀" },
            { key: "skills", label: "Skills", icon: "⚡" },
            { key: "development", label: "Development", icon: "🏆" },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveSection(tab.key)}
              className={`
                flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105
                ${
                  activeSection === tab.key
                    ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg"
                    : "bg-white text-gray-700 hover:bg-gray-50 shadow-md"
                }
              `}
            >
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">{sections[activeSection]}</div>
      </div>
    </section>
  );
};

export default Resume;

// // import React from "react";
// // import { motion } from "framer-motion";
// // import {
// //   FaCalendarAlt,
// //   FaMapMarkerAlt,
// //   FaEnvelope,
// //   FaPhone,
// // } from "react-icons/fa";

// // const Resume = () => {
// //   return (
// //     <section id="resume" className="py-20 bg-white">
// //       <div className="container mx-auto px-4">
// //         {/* Section Title */}
// //         <motion.div
// //           initial={{ opacity: 0, y: 20 }}
// //           whileInView={{ opacity: 1, y: 0 }}
// //           transition={{ duration: 0.8 }}
// //           viewport={{ once: true }}
// //           className="text-center mb-16"
// //         >
// //           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
// //             Resume
// //           </h2>
// //           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
// //             Experience in building decentralized applications, smart contracts,
// //             and full-stack systems with a focus on security and scalability.
// //           </p>
// //         </motion.div>

// //         <div className="max-w-6xl mx-auto">
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
// //             {/* Left Column */}
// //             <motion.div
// //               initial={{ opacity: 0, x: -50 }}
// //               whileInView={{ opacity: 1, x: 0 }}
// //               transition={{ duration: 0.8, delay: 0.2 }}
// //               viewport={{ once: true }}
// //             >
// //               {/* Summary */}
// //               <div className="mb-12">
// //                 <h3 className="text-2xl font-bold text-gray-900 mb-6">
// //                   Summary
// //                 </h3>
// //                 <div className="bg-gray-50 rounded-xl p-6 shadow-lg">
// //                   <h4 className="text-xl font-semibold text-gray-900 mb-3">
// //                     MANEESH MADHUSUDHANAN
// //                   </h4>
// //                   <p className="text-gray-600 italic mb-4">
// //                     Blockchain Developer with expertise in Hyperledger Fabric
// //                     and Ethereum smart contracts. Seeking opportunities to
// //                     develop decentralized solutions in collaborative
// //                     environments.
// //                   </p>
// //                   <ul className="space-y-2 text-gray-600">
// //                     <li className="flex items-center space-x-2">
// //                       <FaMapMarkerAlt className="text-blue-500" />
// //                       <span>Kerala, India</span>
// //                     </li>
// //                     <li className="flex items-center space-x-2">
// //                       <FaPhone className="text-blue-500" />
// //                       <span>+91 8281422036</span>
// //                     </li>
// //                     <li className="flex items-center space-x-2">
// //                       <FaEnvelope className="text-blue-500" />
// //                       <span>maneeshroks@gmail.com</span>
// //                     </li>
// //                   </ul>
// //                 </div>
// //               </div>

// //               {/* Education */}
// //               <div>
// //                 <h3 className="text-2xl font-bold text-gray-900 mb-6">
// //                   Education
// //                 </h3>
// //                 <div className="space-y-6">
// //                   <motion.div
// //                     initial={{ opacity: 0, y: 20 }}
// //                     whileInView={{ opacity: 1, y: 0 }}
// //                     transition={{ duration: 0.6, delay: 0.4 }}
// //                     viewport={{ once: true }}
// //                     className="bg-gray-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
// //                   >
// //                     <h4 className="text-xl font-semibold text-gray-900 mb-2">
// //                       PG Diploma in Blockchain Technology
// //                     </h4>
// //                     <div className="flex items-center space-x-2 text-blue-600 mb-2">
// //                       <FaCalendarAlt />
// //                       <span className="font-medium">2025</span>
// //                     </div>
// //                     <p className="text-gray-600 font-medium">
// //                       Digital University Kerala
// //                     </p>
// //                   </motion.div>

// //                   <motion.div
// //                     initial={{ opacity: 0, y: 20 }}
// //                     whileInView={{ opacity: 1, y: 0 }}
// //                     transition={{ duration: 0.6, delay: 0.6 }}
// //                     viewport={{ once: true }}
// //                     className="bg-gray-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
// //                   >
// //                     <h4 className="text-xl font-semibold text-gray-900 mb-2">
// //                       B.Tech in Electrical & Electronics
// //                     </h4>
// //                     <div className="flex items-center space-x-2 text-blue-600 mb-2">
// //                       <FaCalendarAlt />
// //                       <span className="font-medium">2014 - 2018</span>
// //                     </div>
// //                     <p className="text-gray-600 font-medium">
// //                       Cochin University of Science and Technology (CUSAT)
// //                     </p>
// //                   </motion.div>
// //                 </div>
// //               </div>
// //             </motion.div>

// //             {/* Right Column */}
// //             <motion.div
// //               initial={{ opacity: 0, x: 50 }}
// //               whileInView={{ opacity: 1, x: 0 }}
// //               transition={{ duration: 0.8, delay: 0.4 }}
// //               viewport={{ once: true }}
// //             >
// //               {/* Professional Experience */}
// //               <div className="mb-12">
// //                 <h3 className="text-2xl font-bold text-gray-900 mb-6">
// //                   Professional Experience
// //                 </h3>
// //                 <div className="bg-gray-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
// //                   <h4 className="text-xl font-semibold text-gray-900 mb-2">
// //                     Blockchain Intern
// //                   </h4>
// //                   <div className="flex items-center space-x-2 text-blue-600 mb-3">
// //                     <FaCalendarAlt />
// //                     <span className="font-medium">Apr 2025 – Aug 2025</span>
// //                   </div>
// //                   <p className="text-gray-600 font-medium mb-4">
// //                     Kerala Blockchain Academy, Thiruvananthapuram
// //                   </p>
// //                   <ul className="space-y-2 text-gray-600">
// //                     <li className="flex items-start space-x-2">
// //                       <span className="text-blue-500 font-bold mt-1">•</span>
// //                       <span>
// //                         Developed DAO governance UI using React.js and Ethereum
// //                         smart contracts.
// //                       </span>
// //                     </li>
// //                     <li className="flex items-start space-x-2">
// //                       <span className="text-blue-500 font-bold mt-1">•</span>
// //                       <span>
// //                         Created and deployed ERC-20 governance and farming
// //                         tokens (Sepolia).
// //                       </span>
// //                     </li>
// //                     <li className="flex items-start space-x-2">
// //                       <span className="text-blue-500 font-bold mt-1">•</span>
// //                       <span>
// //                         Integrated Uniswap liquidity and explored IoT-aquaponics
// //                         DAO use case.
// //                       </span>
// //                     </li>
// //                   </ul>
// //                 </div>
// //               </div>

// //               {/* Professional Development */}
// //               <div>
// //                 <h3 className="text-2xl font-bold text-gray-900 mb-6">
// //                   Professional Development
// //                 </h3>

// //                 {/* Workshops & Events */}
// //                 <div className="mb-6">
// //                   <h4 className="text-lg font-semibold text-gray-900 mb-3">
// //                     Workshops & Events
// //                   </h4>
// //                   <div className="bg-gray-50 rounded-xl p-4 shadow-lg">
// //                     <ul className="space-y-2 text-gray-600">
// //                       <li className="flex items-start space-x-2">
// //                         <span className="text-blue-500 font-bold mt-1">•</span>
// //                         <span>
// //                           EthWalk (Devcon Roadshow), Avalanche L1 Deployment
// //                         </span>
// //                       </li>
// //                       <li className="flex items-start space-x-2">
// //                         <span className="text-blue-500 font-bold mt-1">•</span>
// //                         <span>Blockchain in Agriculture (KBA-DailyGurus)</span>
// //                       </li>
// //                       <li className="flex items-start space-x-2">
// //                         <span className="text-blue-500 font-bold mt-1">•</span>
// //                         <span>
// //                           Decentralized Identity & Credentials (KBA & AyanWorks)
// //                         </span>
// //                       </li>
// //                     </ul>
// //                   </div>
// //                 </div>

// //                 {/* Certifications */}
// //                 <div>
// //                   <h4 className="text-lg font-semibold text-gray-900 mb-3">
// //                     Certifications
// //                   </h4>
// //                   <div className="bg-gray-50 rounded-xl p-4 shadow-lg">
// //                     <ul className="space-y-2 text-gray-600">
// //                       <li className="flex items-start space-x-2">
// //                         <span className="text-blue-500 font-bold mt-1">•</span>
// //                         <span>Certified Hyperledger Fabric Developer</span>
// //                       </li>
// //                       <li className="flex items-start space-x-2">
// //                         <span className="text-blue-500 font-bold mt-1">•</span>
// //                         <span>Blockchain Foundation Course</span>
// //                       </li>
// //                       <li className="flex items-start space-x-2">
// //                         <span className="text-blue-500 font-bold mt-1">•</span>
// //                         <span>
// //                           Developer Essentials for Blockchain (Kerala Blockchain
// //                           Academy)
// //                         </span>
// //                       </li>
// //                     </ul>
// //                   </div>
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Resume;

// import React, { useState, useEffect, useRef } from "react";

// const Resume = () => {
//   const [activeSection, setActiveSection] = useState("overview");
//   const [isVisible, setIsVisible] = useState(false);
//   const [animatedStats, setAnimatedStats] = useState({
//     projects: 0,
//     experience: 0,
//     skills: 0,
//   });
//   const [downloadStatus, setDownloadStatus] = useState("idle"); // idle, downloading, success, error
//   const sectionRef = useRef(null);

//   // Personal Information
//   const personalInfo = {
//     name: "MANEESH MADHUSUDHANAN",
//     title: "Blockchain Developer & Smart Contract Engineer",
//     location: "Kerala, India",
//     phone: "+91 8281422036",
//     email: "maneeshroks@gmail.com",
//     github: "https://github.com/maneeshmadhusudhanan",
//     linkedin: "https://linkedin.com/in/maneesh-madhusudhanan",
//     objective:
//       "Blockchain Developer with expertise in Hyperledger Fabric and Ethereum smart contracts. Seeking opportunities to develop decentralized solutions in collaborative environments.",
//   };

//   // Updated Resume Data
//   const resumeData = {
//     education: [
//       {
//         degree: "PG Diploma in Blockchain Technology",
//         institution: "Digital University Kerala",
//         year: "2025",
//         status: "Completed",
//         icon: "🎓",
//       },
//       {
//         degree: "B.Tech in Electrical & Electronics",
//         institution: "CUSAT",
//         year: "2018",
//         status: "Graduated",
//         icon: "⚡",
//       },
//     ],
//     experience: [
//       {
//         position: "Blockchain Intern",
//         company: "Kerala Blockchain Academy",
//         location: "Thiruvananthapuram",
//         duration: "Apr 2025 – Aug 2025",
//         responsibilities: [
//           "Developed DAO governance UI using React.js and Ethereum smart contracts",
//           "Created/deployed ERC20 governance and farming tokens (Sepolia)",
//           "Integrated Uniswap liquidity and explored IoT-aquaponics DAO use case",
//         ],
//         icon: "💼",
//       },
//     ],
//     projects: [
//       {
//         name: "VehicleBlacklistChain",
//         tech: "Hyperledger Fabric, Go",
//         description:
//           "Decentralized vehicle theft reporting system with secure registration and blacklist verification.",
//         icon: "🚗",
//         category: "Blockchain",
//       },
//       {
//         name: "CryptoLedger Exchange",
//         tech: "Ethereum, React",
//         description:
//           "DEX with ERC-20 token (2% fee), JWT auth, and transaction tracking.",
//         icon: "💱",
//         category: "DeFi",
//       },
//       {
//         name: "SmartFacebook DApp",
//         tech: "Ethereum, IPFS",
//         description:
//           "Decentralized social media with token rewards and content storage.",
//         icon: "📱",
//         category: "DApp",
//       },
//       {
//         name: "JobLadder",
//         tech: "MERN Stack",
//         description: "Job portal with resume parsing functionality.",
//         icon: "💼",
//         category: "Web App",
//       },
//     ],
//     skills: {
//       blockchain: [
//         "Ethereum",
//         "Solidity",
//         "Hardhat",
//         "Hyperledger Fabric",
//         "ERC-20/721",
//         "DAO",
//       ],
//       frontend: ["React.js", "Next.js", "Tailwind CSS", "JavaScript"],
//       backend: ["Node.js", "Express.js", "REST APIs", "MongoDB", "MySQL"],
//       tools: ["Git", "Docker", "Remix", "Postman", "VS Code"],
//       soft: ["Problem Solving", "Teamwork", "Leadership", "Time Management"],
//     },
//     development: {
//       workshops: [
//         "EthWalk (Devcon Roadshow)",
//         "Avalanche L1 Deployment",
//         "Blockchain in Agriculture (KBA-DailyGurus)",
//         "Decentralized Identity & Credentials (KBA & AyanWorks)",
//       ],
//       certifications: [
//         "Certified Hyperledger Fabric Developer",
//         "Blockchain Foundation Course",
//         "Developer Essentials for Blockchain (Kerala Blockchain Academy)",
//       ],
//       focus: [
//         "Enterprise integration",
//         "Traceability in agritech",
//         "Web3 governance",
//         "Tokenomics",
//         "Smart contract security",
//         "Blockchain identity systems",
//       ],
//     },
//     languages: [
//       { name: "English", level: "Fluent", percentage: 95 },
//       { name: "Malayalam", level: "Native", percentage: 100 },
//       { name: "Hindi", level: "Conversational", percentage: 75 },
//       { name: "Tamil", level: "Basic", percentage: 60 },
//     ],
//   };

//   const stats = [
//     { label: "Projects Completed", value: 4, suffix: "+" },
//     { label: "Months Experience", value: 5, suffix: "" },
//     { label: "Technologies Mastered", value: 20, suffix: "+" },
//   ];

//   // Intersection Observer Effect
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           // Animate stats
//           stats.forEach((stat, index) => {
//             setTimeout(() => {
//               animateStat(
//                 stat.label.toLowerCase().includes("project")
//                   ? "projects"
//                   : stat.label.toLowerCase().includes("experience")
//                   ? "experience"
//                   : "skills",
//                 stat.value
//               );
//             }, index * 500);
//           });
//         }
//       },
//       { threshold: 0.2 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   const animateStat = (key, target) => {
//     let current = 0;
//     const increment = target / 30;
//     const timer = setInterval(() => {
//       current += increment;
//       if (current >= target) {
//         current = target;
//         clearInterval(timer);
//       }
//       setAnimatedStats((prev) => ({ ...prev, [key]: Math.floor(current) }));
//     }, 50);
//   };

//   // Download Resume Handler
//   const handleDownloadResume = async () => {
//     setDownloadStatus("downloading");

//     try {
//       // Simulate PDF generation/download
//       await new Promise((resolve) => setTimeout(resolve, 2000));

//       // Updated resume content
//       const resumeContent = generateUpdatedResumeText();
//       const blob = new Blob([resumeContent], { type: "text/plain" });
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.style.display = "none";
//       a.href = url;
//       a.download = "Maneesh_Madhusudhanan_Resume.txt";
//       document.body.appendChild(a);
//       a.click();
//       window.URL.revokeObjectURL(url);
//       document.body.removeChild(a);

//       setDownloadStatus("success");
//       setTimeout(() => setDownloadStatus("idle"), 3000);
//     } catch (error) {
//       console.error("Download failed:", error);
//       setDownloadStatus("error");
//       setTimeout(() => setDownloadStatus("idle"), 3000);
//     }
//   };

//   const generateUpdatedResumeText = () => {
//     return `MANEESH MADHUSUDHANAN
// +91 8281422036 ⋄ Kerala, India
// maneeshroks@gmail.com ⋄ Github ⋄ Linkedin

// OBJECTIVE
// Blockchain Developer with expertise in Hyperledger Fabric and Ethereum smart contracts. Seeking opportunities to develop decentralized solutions in collaborative environments.

// EDUCATION
// PG Diploma in Blockchain Technology, Digital University Kerala                                    2025
// B.Tech in Electrical & Electronics, CUSAT                                                       2018

// SKILLS
// Blockchain: Ethereum, Solidity, Hardhat, Hyperledger Fabric, ERC-20/721, DAO
// Frontend: React.js, Next.js, Tailwind CSS, JavaScript
// Backend: Node.js, Express.js, REST APIs, MongoDB, MySQL
// Tools: Git, Docker, Remix, Postman, VS Code
// Soft Skills: Problem Solving, Teamwork, Leadership, Time Management

// PROFESSIONAL EXPERIENCE
// Blockchain Intern
// Kerala Blockchain Academy, Thiruvananthapuram                                        Apr 2025 – Aug 2025
// • Developed DAO governance UI using React.js and Ethereum smart contracts
// • Created/deployed ERC20 governance and farming tokens (Sepolia)
// • Integrated Uniswap liquidity and explored IoT-aquaponics DAO use case

// PROJECTS
// VehicleBlacklistChain (Hyperledger Fabric, Go): Decentralized vehicle theft reporting system with secure registration and blacklist verification.

// CryptoLedger Exchange (Ethereum, React): DEX with ERC-20 token (2% fee), JWT auth, and transaction tracking.

// SmartFacebook DApp (Ethereum, IPFS): Decentralized social media with token rewards and content storage.

// JobLadder (MERN Stack): Job portal with resume parsing.

// PROFESSIONAL DEVELOPMENT
// • Workshops & Events: EthWalk (Devcon Roadshow), Avalanche L1 Deployment, Blockchain in Agriculture (KBA-DailyGurus), Decentralized Identity & Credentials (KBA & AyanWorks)
// • Certifications: Certified Hyperledger Fabric Developer, Blockchain Foundation Course, Developer Essentials for Blockchain (Kerala Blockchain Academy)
// • Learning Focus: Enterprise integration, traceability in agritech, Web3 governance, tokenomics, smart contract security, and blockchain identity systems.

// LANGUAGES
// English (Fluent), Malayalam (Native), Hindi (Conversational), Tamil`;
//   };

//   const SkillBar = ({ skill, percentage, delay }) => (
//     <div
//       className={`mb-4 transition-all duration-500 ${
//         isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"
//       }`}
//       style={{ transitionDelay: `${delay}ms` }}
//     >
//       <div className="flex justify-between items-center mb-2">
//         <span className="font-medium text-gray-700">{skill}</span>
//         <span className="text-sm text-blue-600 font-semibold">
//           {percentage}%
//         </span>
//       </div>
//       <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
//         <div
//           className="h-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-full transition-all duration-1500 ease-out"
//           style={{
//             width: isVisible ? `${percentage}%` : "0%",
//             transitionDelay: `${delay + 300}ms`,
//           }}
//         />
//       </div>
//     </div>
//   );

//   const ProjectCard = ({ project, index }) => (
//     <div
//       className={`
//       bg-white rounded-xl p-6 shadow-lg border-l-4 border-blue-500 hover:shadow-xl
//       transform transition-all duration-500 hover:-translate-y-1
//       ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
//     `}
//       style={{ transitionDelay: `${index * 150}ms` }}
//     >
//       <div className="flex items-start space-x-4 mb-4">
//         <div className="text-3xl">{project.icon}</div>
//         <div className="flex-1">
//           <div className="flex items-center justify-between mb-2">
//             <h4 className="text-xl font-bold text-gray-900">{project.name}</h4>
//             <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
//               {project.category}
//             </span>
//           </div>
//           <p className="text-blue-600 font-medium text-sm mb-3">
//             {project.tech}
//           </p>
//           <p className="text-gray-700 leading-relaxed">{project.description}</p>
//         </div>
//       </div>
//     </div>
//   );

//   const sections = {
//     overview: (
//       <div className="space-y-8">
//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//           {stats.map((stat, index) => (
//             <div
//               key={stat.label}
//               className={`
//               bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6 text-center
//               transform transition-all duration-500 hover:scale-105 hover:shadow-lg
//               ${
//                 isVisible
//                   ? "opacity-100 translate-y-0"
//                   : "opacity-0 translate-y-4"
//               }
//             `}
//               style={{ transitionDelay: `${index * 200}ms` }}
//             >
//               <div className="text-3xl font-bold text-blue-600 mb-2">
//                 {stat.label.includes("Projects")
//                   ? animatedStats.projects
//                   : stat.label.includes("Experience") ||
//                     stat.label.includes("Months")
//                   ? animatedStats.experience
//                   : animatedStats.skills}
//                 {stat.suffix}
//               </div>
//               <div className="text-sm text-gray-600 font-medium">
//                 {stat.label}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Objective */}
//         <div
//           className={`bg-white rounded-xl p-6 shadow-lg border-l-4 border-blue-500
//           transition-all duration-500 ${
//             isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"
//           }`}
//         >
//           <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
//             <span className="mr-3">🎯</span> Career Objective
//           </h3>
//           <p className="text-gray-700 leading-relaxed">
//             {personalInfo.objective}
//           </p>
//         </div>

//         {/* Key Highlights */}
//         <div
//           className={`bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white
//           transition-all duration-500 ${
//             isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"
//           }`}
//           style={{ transitionDelay: "400ms" }}
//         >
//           <h3 className="text-xl font-bold mb-4">🚀 Key Highlights</h3>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div className="flex items-center space-x-3">
//               <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
//               <span>Hyperledger Fabric Certified Developer</span>
//             </div>
//             <div className="flex items-center space-x-3">
//               <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
//               <span>4+ Blockchain Projects Deployed</span>
//             </div>
//             <div className="flex items-center space-x-3">
//               <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
//               <span>Smart Contract Security Expert</span>
//             </div>
//             <div className="flex items-center space-x-3">
//               <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
//               <span>Full-Stack DApp Development</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     ),

//     education: (
//       <div className="space-y-6">
//         {resumeData.education.map((edu, index) => (
//           <div
//             key={index}
//             className={`
//             bg-white rounded-xl p-6 shadow-lg hover:shadow-xl border border-gray-100
//             transform transition-all duration-500 hover:-translate-y-1
//             ${
//               isVisible
//                 ? "opacity-100 translate-y-0"
//                 : "opacity-0 translate-y-4"
//             }
//           `}
//             style={{ transitionDelay: `${index * 200}ms` }}
//           >
//             <div className="flex items-start space-x-4">
//               <div className="text-3xl">{edu.icon}</div>
//               <div className="flex-1">
//                 <h4 className="text-xl font-bold text-gray-900 mb-2">
//                   {edu.degree}
//                 </h4>
//                 <p className="text-blue-600 font-medium mb-2">
//                   {edu.institution}
//                 </p>
//                 <div className="flex items-center space-x-4">
//                   <span className="text-gray-600 flex items-center">
//                     <svg
//                       className="w-4 h-4 mr-1"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                       />
//                     </svg>
//                     {edu.year}
//                   </span>
//                   <span
//                     className={`px-3 py-1 rounded-full text-xs font-medium ${
//                       edu.status === "Completed"
//                         ? "bg-green-100 text-green-800"
//                         : "bg-blue-100 text-blue-800"
//                     }`}
//                   >
//                     {edu.status}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     ),

//     experience: (
//       <div className="space-y-6">
//         {resumeData.experience.map((exp, index) => (
//           <div
//             key={index}
//             className={`
//             bg-white rounded-xl p-6 shadow-lg border-l-4 border-blue-500
//             transition-all duration-500 ${
//               isVisible
//                 ? "opacity-100 translate-x-0"
//                 : "opacity-0 -translate-x-4"
//             }`}
//             style={{ transitionDelay: `${index * 200}ms` }}
//           >
//             <div className="flex items-start space-x-4 mb-4">
//               <div className="text-3xl">{exp.icon}</div>
//               <div className="flex-1">
//                 <h4 className="text-xl font-bold text-gray-900 mb-1">
//                   {exp.position}
//                 </h4>
//                 <p className="text-blue-600 font-medium mb-2">
//                   {exp.company}, {exp.location}
//                 </p>
//                 <span className="text-gray-600 text-sm bg-gray-100 px-3 py-1 rounded-full">
//                   {exp.duration}
//                 </span>
//               </div>
//             </div>
//             <div className="space-y-2">
//               <h5 className="font-semibold text-gray-800 mb-3">
//                 Key Responsibilities:
//               </h5>
//               {exp.responsibilities.map((resp, respIndex) => (
//                 <div key={respIndex} className="flex items-start space-x-3">
//                   <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
//                   <p className="text-gray-700">{resp}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>
//     ),

//     projects: (
//       <div className="space-y-6">
//         {resumeData.projects.map((project, index) => (
//           <ProjectCard key={project.name} project={project} index={index} />
//         ))}
//       </div>
//     ),

//     skills: (
//       <div className="space-y-8">
//         {Object.entries(resumeData.skills).map(
//           ([category, skills], categoryIndex) => (
//             <div
//               key={category}
//               className={`
//             bg-white rounded-xl p-6 shadow-lg
//             transition-all duration-500 ${
//               isVisible
//                 ? "opacity-100 translate-y-0"
//                 : "opacity-0 translate-y-4"
//             }
//           `}
//               style={{ transitionDelay: `${categoryIndex * 150}ms` }}
//             >
//               <h4 className="text-lg font-bold text-gray-900 mb-4 capitalize flex items-center">
//                 <span className="mr-2">
//                   {category === "blockchain"
//                     ? "⛓️"
//                     : category === "frontend"
//                     ? "🎨"
//                     : category === "backend"
//                     ? "⚙️"
//                     : category === "tools"
//                     ? "🛠️"
//                     : "🧠"}
//                 </span>
//                 {category.charAt(0).toUpperCase() + category.slice(1)} Skills
//               </h4>
//               <div className="flex flex-wrap gap-2">
//                 {skills.map((skill, skillIndex) => (
//                   <span
//                     key={skillIndex}
//                     className={`
//                   px-3 py-1 bg-gradient-to-r from-blue-100 to-purple-100 text-blue-800 rounded-full text-sm font-medium
//                   transform transition-all duration-300 hover:scale-105 hover:shadow-md cursor-default
//                   ${
//                     isVisible
//                       ? "opacity-100 translate-y-0"
//                       : "opacity-0 translate-y-2"
//                   }
//                 `}
//                     style={{
//                       transitionDelay: `${
//                         categoryIndex * 150 + skillIndex * 50
//                       }ms`,
//                     }}
//                   >
//                     {skill}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           )
//         )}

//         {/* Language Skills */}
//         <div
//           className={`bg-white rounded-xl p-6 shadow-lg
//           transition-all duration-500 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
//           }`}
//           style={{ transitionDelay: "600ms" }}
//         >
//           <h4 className="text-lg font-bold text-gray-900 mb-6 flex items-center">
//             <span className="mr-2">🌐</span> Languages
//           </h4>
//           {resumeData.languages.map((lang, index) => (
//             <SkillBar
//               key={lang.name}
//               skill={`${lang.name} (${lang.level})`}
//               percentage={lang.percentage}
//               delay={index * 100}
//             />
//           ))}
//         </div>
//       </div>
//     ),

//     development: (
//       <div className="space-y-6">
//         {/* Workshops */}
//         <div
//           className={`bg-white rounded-xl p-6 shadow-lg
//           transition-all duration-500 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
//           }`}
//         >
//           <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
//             <span className="mr-2">🎓</span> Workshops & Events
//           </h4>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//             {resumeData.development.workshops.map((workshop, index) => (
//               <div
//                 key={index}
//                 className={`
//                 flex items-center space-x-3 p-3 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg
//                 transition-all duration-300 hover:shadow-md
//                 ${
//                   isVisible
//                     ? "opacity-100 translate-x-0"
//                     : "opacity-0 -translate-x-2"
//                 }
//               `}
//                 style={{ transitionDelay: `${index * 100}ms` }}
//               >
//                 <div className="w-2 h-2 bg-purple-500 rounded-full flex-shrink-0"></div>
//                 <span className="text-gray-700 font-medium text-sm">
//                   {workshop}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Certifications */}
//         <div
//           className={`bg-white rounded-xl p-6 shadow-lg
//           transition-all duration-500 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
//           }`}
//           style={{ transitionDelay: "200ms" }}
//         >
//           <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
//             <span className="mr-2">🏆</span> Professional Certifications
//           </h4>
//           <div className="space-y-3">
//             {resumeData.development.certifications.map((cert, index) => (
//               <div
//                 key={index}
//                 className={`
//                 flex items-center space-x-3 p-3 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg
//                 transition-all duration-300 hover:shadow-md
//                 ${
//                   isVisible
//                     ? "opacity-100 translate-x-0"
//                     : "opacity-0 -translate-x-2"
//                 }
//               `}
//                 style={{ transitionDelay: `${200 + index * 100}ms` }}
//               >
//                 <div className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0"></div>
//                 <span className="text-gray-700 font-medium">{cert}</span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Learning Focus */}
//         <div
//           className={`bg-white rounded-xl p-6 shadow-lg
//           transition-all duration-500 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
//           }`}
//           style={{ transitionDelay: "400ms" }}
//         >
//           <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
//             <span className="mr-2">🎯</span> Learning Focus Areas
//           </h4>
//           <div className="flex flex-wrap gap-2">
//             {resumeData.development.focus.map((focus, index) => (
//               <span
//                 key={index}
//                 className={`
//                 px-3 py-1 bg-gradient-to-r from-orange-100 to-red-100 text-orange-800 rounded-full text-sm font-medium
//                 transform transition-all duration-300 hover:scale-105 hover:shadow-md cursor-default
//                 ${
//                   isVisible
//                     ? "opacity-100 translate-y-0"
//                     : "opacity-0 translate-y-2"
//                 }
//               `}
//                 style={{ transitionDelay: `${400 + index * 50}ms` }}
//               >
//                 {focus}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//     ),
//   };

//   return (
//     <section
//       ref={sectionRef}
//       id="resume"
//       className="py-20 bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 min-h-screen"
//     >
//       <div className="container mx-auto px-4">
//         {/* Header */}
//         <div
//           className={`text-center mb-12 transition-all duration-1000 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
//           }`}
//         >
//           <div className="inline-block p-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6">
//             <div className="bg-white rounded-full px-6 py-2">
//               <span className="text-sm font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
//                 BLOCKCHAIN DEVELOPER PORTFOLIO
//               </span>
//             </div>
//           </div>

//           <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">
//             {personalInfo.name}
//           </h2>
//           <p className="text-xl md:text-2xl text-blue-600 font-medium mb-6">
//             {personalInfo.title}
//           </p>

//           {/* Contact Information */}
//           <div className="flex flex-wrap justify-center gap-6 mb-8">
//             <div className="flex items-center space-x-2 text-gray-600">
//               <svg
//                 className="w-5 h-5"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//                 />
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//                 />
//               </svg>
//               <span>{personalInfo.location}</span>
//             </div>
//             <div className="flex items-center space-x-2 text-gray-600">
//               <svg
//                 className="w-5 h-5"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                 />
//               </svg>
//               <span>{personalInfo.phone}</span>
//             </div>
//             <div className="flex items-center space-x-2 text-gray-600">
//               <svg
//                 className="w-5 h-5"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//                 />
//               </svg>
//               <span>{personalInfo.email}</span>
//             </div>
//           </div>

//           {/* Download Resume Button */}
//           <button
//             onClick={handleDownloadResume}
//             disabled={downloadStatus === "downloading"}
//             className={`
//               inline-flex items-center space-x-3 px-8 py-4 rounded-full font-semibold
//               transition-all duration-300 transform hover:scale-105 shadow-lg
//               ${
//                 downloadStatus === "downloading"
//                   ? "bg-gray-400 cursor-not-allowed"
//                   : downloadStatus === "success"
//                   ? "bg-green-500 text-white"
//                   : downloadStatus === "error"
//                   ? "bg-red-500 text-white"
//                   : "bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700"
//               }
//             `}
//           >
//             {downloadStatus === "downloading" ? (
//               <>
//                 <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
//                 <span>Generating Resume...</span>
//               </>
//             ) : downloadStatus === "success" ? (
//               <>
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M5 13l4 4L19 7"
//                   />
//                 </svg>
//                 <span>Resume Downloaded!</span>
//               </>
//             ) : downloadStatus === "error" ? (
//               <>
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//                 <span>Download Failed - Retry</span>
//               </>
//             ) : (
//               <>
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                   />
//                 </svg>
//                 <span>Download Resume</span>
//               </>
//             )}
//           </button>
//         </div>

//         {/* Navigation Tabs */}
//         <div
//           className={`flex flex-wrap justify-center gap-2 mb-12 transition-all duration-1000 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
//           }`}
//           style={{ transitionDelay: "200ms" }}
//         >
//           {[
//             { key: "overview", label: "Overview", icon: "👨‍💼" },
//             { key: "education", label: "Education", icon: "🎓" },
//             { key: "experience", label: "Experience", icon: "💼" },
//             { key: "projects", label: "Projects", icon: "🚀" },
//             { key: "skills", label: "Skills", icon: "⚡" },
//             { key: "development", label: "Development", icon: "🏆" },
//           ].map((tab) => (
//             <button
//               key={tab.key}
//               onClick={() => setActiveSection(tab.key)}
//               className={`
//                 flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105
//                 ${
//                   activeSection === tab.key
//                     ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg"
//                     : "bg-white text-gray-700 hover:bg-gray-50 shadow-md"
//                 }
//               `}
//             >
//               <span>{tab.icon}</span>
//               <span>{tab.label}</span>
//             </button>
//           ))}
//         </div>

//         {/* Content */}
//         <div className="max-w-4xl mx-auto">{sections[activeSection]}</div>
//       </div>
//     </section>
//   );
// };

// export default Resume;
